export default "__VITE_ASSET__DoQ6JQsH__"